import SentimentAnalysis from './SentimentAnalysis';

export default SentimentAnalysis;
